import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { filledToggleGroupSx } from "@shared";

import { CourtHearingsGrouping } from "@/pages/court-hearings/CourtHearings.types";
import { useTranslation } from "@/translations";

interface Props {
  value: CourtHearingsGrouping;
  onChange: (value: CourtHearingsGrouping) => void;
}

export function CourtHearingsGroupingToggle({ value, onChange }: Props) {
  const { t } = useTranslation();

  return (
    <ToggleButtonGroup
      exclusive
      value={value}
      aria-label={t("courtHearings.filter.groupingAriaLabel")}
      onChange={(_event, next: CourtHearingsGrouping | null) => {
        if (next !== null) {
          onChange(next);
        }
      }}
      sx={filledToggleGroupSx}
    >
      <ToggleButton value="byDate" sx={{ minWidth: 120 }}>
        {t("courtHearings.grouping.byDate")}
      </ToggleButton>
      <ToggleButton value="byCourt" sx={{ minWidth: 120 }}>
        {t("courtHearings.grouping.byCourt")}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
